/**
* Money Format
*/
export function moneyFormat(price, currency = 'USD', toFixed = 2) {
  if (!price && price !== 0) {
    return ''
  }

  if (price === 'preload') {
    price = '--.--'
  } else {
    if (typeof price === 'number') {
      price = price.toFixed(toFixed)
    } else {
      price = parseFloat(price?.replace(/[^0-9.-]+/g, '')).toFixed(toFixed)
    }
  }
    
  currency = typeof currency === 'string' ? currency : 'USD'

  if (currency === 'USD') {
    return '$' + price
  }

  return currency + ' ' + price
}

/**
* input example: dateString = '2023-07-10 07:21:40'
* Date Format to mm/dd/YYYY
*/
export function dateFormat(dateString, options = {}) {
  if (!dateString || dateString === 'na' || dateString === 'n/a') {
    return 'N/A'
  }
  
  if (dateString.includes(' - ')) { 
    return dateString
  }

  const date = new Date(dateString)
  const month = date.getMonth() + 1
  const day = date.getDate()
  const year = date.getFullYear()

  let formattedDate = month + '/' + day + '/' + year

  if (options.showTime) {
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const ampm = hours >= 12 ? 'PM' : 'AM'
    const formattedHours = hours % 12 || 12
    const formattedMinutes = minutes.toString().padStart(2, '0')

    const time = `${formattedHours}:${formattedMinutes} ${ampm}`
    formattedDate = formattedDate + ' ' + time
  }

  return formattedDate
}

/**
* Address Format
*/
export function addressFormat(address) {
  if (!address) { 
    return false
  }

  const parts = []

  if (address.firstname || address.lastname) {
    parts.push(
      [address.firstname, address.lastname].filter(Boolean).join(' ')
    )
  }

  if (address.company) {
    parts.push(address.company)
  }

  if (address.address_1) {
    parts.push(address.address_1)
  }

  if (address.city || address.postcode || address.zone) {
    const cityZonePostcode = [
      address.city,
      address.zone ? address.zone : '',
      address.postcode ? address.postcode : ''
    ].filter(Boolean).join(' ')
    parts.push(cityZonePostcode)
  }

  if (address.country) {
    parts.push(address.country)
  }

  if (address.tax_id) {
    parts.push(address.tax_id)
  }

  return parts.join(', ')
}

/*
* Status Format
*/
export function statusFormat(value, statuses) {
  if (!value) { 
    return false
  }
  
  if (statuses?.find(n => n.code === value)?.severity) { 
    return statuses?.find(n => n.code === value)
  }

  return {
    severity: 'primary',
    name: value
  }
}